import { RouterFormErrors, RouterPayload, ROUTER_MODES } from "./types";

export const IP_REGEX =
  /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$|^(?:[A-F0-9]{1,4}:){7}[A-F0-9]{1,4}$/i;

export function validateRouter(
  router: Partial<RouterPayload>,
): RouterFormErrors {
  const errors: RouterFormErrors = {};

  if (!router.name?.trim()) errors.name = "Nome é obrigatório";

  if (!router.mode?.trim()) errors.mode = "Modo é obrigatório";
  else if (!ROUTER_MODES.includes(router.mode.trim()))
    errors.mode = `Modo inválido`;

  (["sourceIp", "snmpIp"] as const).forEach((field) => {
    const value = router[field]?.toString().trim();
    if (!value) errors[field] = "IP é obrigatório";
    else if (!IP_REGEX.test(value)) errors[field] = "IP inválido";
  });

  (["mostragemIpv4", "mostragemIpv6"] as const).forEach((field) => {
    const value = router[field]?.toString().trim();
    if (!value) errors[field] = "Amostragem é obrigatória";
    else if (!/^\d+$/.test(value)) errors[field] = "Informe apenas números";
  });

  if (!router.snmpCommunity?.trim())
    errors.snmpCommunity = "Comunidade é obrigatória";

  const port = router.snmpPort?.toString().trim();
  if (!port) errors.snmpPort = "Porta é obrigatória";
  else if (!/^\d+$/.test(port)) errors.snmpPort = "Informe apenas números";

  return errors;
}

export const hasErrors = (errors: RouterFormErrors): boolean =>
  Object.keys(errors).length > 0;
